// §80 Client brand colour: remaps the portal's gold accent (and optionally tints the background) to the client's colour.
export const HEX = /^#[0-9a-f]{6}$/i;
export const PRESETS = ["#D4AF37", "#2563EB", "#10B981", "#EF4444", "#F97316", "#EC4899", "#14B8A6", "#8B5CF6"];

const lum = (hex) => { const c = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255).map((v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4)); return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]; };
export const fgOn = (hex) => (lum(hex) > 0.179 ? "#000000" : "#FFFFFF");

const S = "[data-client-theme]";
// Tailwind arbitrary classes used for the gold accent across reused components.
export const themeCss = (accent, tint) => {
  if (!HEX.test(accent || "")) return "";
  const css = [
    `${S}{--ca:${accent};--ca-fg:${fgOn(accent)}}`,
    `${S} .bg-\\[\\#D4AF37\\],${S} .hover\\:bg-\\[\\#F3C649\\]:hover{background-color:var(--ca)!important}`,
    `${S} .bg-\\[\\#D4AF37\\].text-black,${S} .bg-\\[\\#D4AF37\\] .text-black{color:var(--ca-fg)!important}`,
    `${S} .text-\\[\\#D4AF37\\],${S} .text-\\[\\#F3C649\\],${S} .hover\\:text-\\[\\#F3C649\\]:hover,${S} .hover\\:text-\\[\\#D4AF37\\]:hover{color:var(--ca)!important}`,
    `${S} .border-\\[\\#D4AF37\\],${S} [class*="border-[#D4AF37]/"]{border-color:color-mix(in srgb,var(--ca) 55%,transparent)!important}`,
    `${S} [class*="bg-[#D4AF37]/"]{background-color:color-mix(in srgb,var(--ca) 12%,transparent)!important}`,
    `${S} .accent-\\[\\#D4AF37\\]{accent-color:var(--ca)}`,
  ];
  if (tint) css.push(
    `${S}{background-color:color-mix(in srgb,var(--ca) 7%,#09090B)!important}`,
    `${S} .bg-\\[\\#0f0f12\\],${S} .bg-\\[\\#121215\\],${S} .bg-\\[\\#0E0E11\\],${S} .bg-\\[\\#18181B\\]{background-color:color-mix(in srgb,var(--ca) 6%,#111114)!important}`,
    `${S} .border-\\[\\#27272A\\]{border-color:color-mix(in srgb,var(--ca) 18%,#27272A)!important}`,
  );
  css.push(`${S} [data-our-brand] .text-\\[\\#D4AF37\\],${S} [data-our-brand] .text-\\[\\#F3C649\\]{color:#D4AF37!important}`);
  return css.join("\n");
};
